import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

@ngCore.Component({
  imports: [ds.loader.Component],
  selector: 'atn-app-landing-page',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {}
